import type * as React from "react";

// eslint-disable-next-line no-restricted-imports
import { useAppToggleButton } from "@1js/acui-button/lib/Next";

import { useRibbonControlLabel } from "../../RibbonButton/next";
import { useRibbonButtonVariant } from "../../RibbonButton/next/useRibbonButtonVariant";
import { useCommonRibbonButtonLabelClassNames } from "../../next/commonRibbonButtonStyles.styles";
import type {
  RibbonToggleButtonProps,
  RibbonToggleButtonState,
} from "./RibbonToggleButton.types";

export const useRibbonToggleButton = (
  props: RibbonToggleButtonProps,
  ref: React.Ref<HTMLButtonElement>
): RibbonToggleButtonState => {
  const { dataAutomationType, label, onRenderText, size, variant, variantId } =
    props;

  const appToggleButtonState = useAppToggleButton(
    {
      ...props,
      children: useRibbonControlLabel(
        label,
        size,
        onRenderText,
        useCommonRibbonButtonLabelClassNames(size)
      ),
      dataAutomationType: dataAutomationType ?? "RibbonToggleButton",
    },
    ref
  );

  useRibbonButtonVariant(
    appToggleButtonState as RibbonToggleButtonState,
    variant as RibbonToggleButtonState["variant"],
    variantId as RibbonToggleButtonState["variantId"]
  );

  return appToggleButtonState;
};
